module.exports = __webpack_public_path__ + "img/border_bg_img@2x.8afb6178.png";